import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

const client = createClient({
  projectId: "uhmyqvp4",
  dataset: "production",
  apiVersion: "2024-02-10",
  token: "sknEIawGKPkT8Ja3aB500DKi1PdP7H0P6tJuYKMOd3gJ1lMgCCnSwQxsbMoNxQhLEccbHN4FMbKwGdfAbpkMYFWCgKxo2HISROGdFmo7YBuoMTVoU8y4U4KqxxnF9RUzLyj4cgDWGwpLpUSwW2WdvEdGTdCqezkChsz7mN6HOUwEXUf5INK7",
  useCdn: false,
  ignoreBrowserTokenWarning: true,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export default client;